import styled from 'styled-components'

export const ShadowCardContainer = styled.div`
  background-color: ${props => props.theme.colors.white};
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.1);
`
